import { useAuth } from "../../auth/model/AuthContext";
import OrderView from "../components/OrderView";

export const CustomerHomePage = () => {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div style={{ width: "100%" }}>
      <OrderView />
    </div>
  );
};

export default CustomerHomePage;
